import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate, useParams } from "react-router-dom";

export function IcpNoDataBanner() {
  const navigate = useNavigate();
  const { id: workspaceId } = useParams();

  const handleCreateProfile = () => {
    navigate(`/projects/${workspaceId}/customer-profile`);
  };

  return (
    <Alert
      variant="standard"
      severity="info"
      sx={{
        mb: 2,
        bgcolor: "#e5f6fd",
      }}
    >
      <Box>
        <AlertTitle>Customer Profile Missing</AlertTitle>
        <Typography variant="body2" sx={{ fontSize: "11px" }}>
          You have not yet created a Customer Profile. Create one now, and then
          you can use the resulting data as part of this Workspace.
        </Typography>
      </Box>
      <Box display="flex" justifyContent="flex-end" padding="8px 16px 0px 0px">
        <Button
          id="create-customer-profile-button"
          variant="text"
          size="small"
          color="primary"
          onClick={handleCreateProfile}
        >
          create customer profile
        </Button>
      </Box>
    </Alert>
  );
}
